import './style.css'
import { inject, configureCompat } from 'vue'
import { useAuth } from '~vueutil/auth.js'
import { Notification } from './notification/index.js'
import Avatar from './avatar/index.js'

import * as render from './render.pug'

configureCompat({
  INSTANCE_CHILDREN: true
})

export default {
  ...render,
  components: {
    Notification,
    Avatar
  },
  setup () {
    const auth = useAuth()
    return { auth }
  },
  provide () {
    const { $bvToast } = this
    return { $bvToast }
  }
}

export function useToast () {
  return inject('$bvToast')
}
